export const DEFAULT_IMAGE_TYPE = '.png,.jpg,.jpeg' // 图片的默认类型